import {
  faChevronRight as chevronRightSolid,
  faUserCircle as contactsSolid,
  faAddressBook,
  faAnalytics,
  faArrowCircleDown,
  faArrowCircleLeft as faArrowCircleLeftSolid,
  faArrowCircleRight as faArrowCircleRightSolid,
  faArrowCircleUp,
  faArrowDown as faArrowDownSolid,
  faArrowLeft as faArrowLeftSolid,
  faArrowUp as faArrowUpSolid,
  faBarcode,
  faBars,
  faBell,
  faBellSlash,
  faBold,
  faCactus as faCactusSolid,
  faCalendar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCheck,
  faCheckCircle as faCheckCircleSolid,
  faCirclePhone,
  faCircle as faCircleSolid,
  faCircleVideo,
  faClipboardList as faClipboardListCheckSolid,
  faClock,
  faCloudSun,
  faCog,
  faCommentDots as faCommentDotsSolid,
  faCommentsAlt as faCommentsAltSolid,
  faCompressArrowsAlt,
  faCopy,
  faDizzy as faDizzySolid,
  faDoorOpen,
  faDownload as faDownloadSolid,
  faEllipsisH,
  faEllipsisV,
  faEnvelope as faEnvelopeSolid,
  faExchange,
  faExclamationCircle as faExclamationCircleSolid,
  faFile as faFileSolid,
  faFileUpload,
  faFlag as faFlagSolid,
  faFrownOpen as faFrownOpenSolid,
  faGrid,
  faGrid2,
  faGrimace as faGrimaceSolid,
  faGrinBeam as faGrinBeamSolid,
  faGrin as faGrinSolid,
  faGrinStars as faGrinStarsSolid,
  faGripDotsVertical,
  faGripVertical as faGripVerticalSolid,
  faHeadset as faHeadsetSolid,
  faHeart as faHeartSolid,
  faHome as faHomeSolid,
  faImage,
  faIndent,
  faInfoCircle,
  faKey as faKeySolid,
  faKeyboard,
  faKissWinkHeart as faKissWinkHeartSolid,
  faLightbulbOn as faLightbulbOnSolid,
  faList,
  faListOl,
  faListUl,
  faLocationDot as faLocationSolid,
  faLock as faLockSolid,
  faMeh as faMehSolid,
  faMicrophoneSlash as faMicrophoneSlashSolid,
  faMicrophone as faMicrophoneSolid,
  faPaperPlane as faPaperPlaneSolid,
  faPause as faPauseSolid,
  faPen as faPenSolid,
  faPhoneHangup,
  faPhoneOffice,
  faPhonePlus as faPhonePlusSolid,
  faPhoneSlash,
  faPhone as faPhoneSolid,
  faPlay as faPlaySolid,
  faQuestion,
  faQuestionCircle as faQuestionCircleSolid,
  faRectangleWide,
  faReplyAll,
  faReply as faReplySolid,
  faSadTear as faSadTearSolid,
  faSearch as faSearchSolid,
  faShieldCheck,
  faShieldExclamation,
  faSmileBeam as faSmileBeamSolid,
  faSmile as faSmileSolid,
  faSparkles,
  faSquareB,
  faStar as faStarSolid,
  faStop as faStopSolid,
  faTasks,
  faThLarge,
  faThumbsDown as faThumbsDownSolid,
  faThumbsUp as faThumbsUpSolid,
  faTimesCircle as faTimesCircleSolid,
  faUserCog,
  faUserFriends as faUserFriendsSolid,
  faUserPlus as faUserPlusSolid,
  faUser as faUserSolid,
  faUsers as faUsersSolid,
  faVideoSlash as faVideoOffSolid,
  faVideo as faVideoOnSolid,
  faVoicemail as faVoicemailSolid,
  faVolume,
  faWifiExclamation,
} from '@fortawesome/pro-solid-svg-icons';

const proSolidSvgIcons = {
  addressBook: faAddressBook,
  analyticsSolid: faAnalytics,
  apps: faGrid,
  barcodeSolid: faBarcode,
  bars: faBars,
  bold: faBold,
  cactusSolid: faCactusSolid,
  calendarSolid: faCalendar,
  caretDown: faCaretDown,
  caretLeft: faCaretLeft,
  caretRight: faCaretRight,
  caretUp: faCaretUp,
  check: faCheck,
  clipboardListSolid: faClipboardListCheckSolid,
  checkCircleSolid: faCheckCircleSolid,
  chevronRightSolid,
  circleDown: faArrowCircleDown,
  circleRight: faArrowCircleRightSolid,
  circlePhoneSolid: faCirclePhone,
  circleUp: faArrowCircleUp,
  circleVideoSolid: faCircleVideo,
  clockSolid: faClock,
  commentsSolid: faCommentsAltSolid,
  contactsSolid: contactsSolid,
  copySolid: faCopy,
  cloudSun: faCloudSun,
  doorOpen: faDoorOpen,
  downloadSolid: faDownloadSolid,
  downSolid: faArrowDownSolid,
  exchange: faExchange,
  exclamationSolid: faExclamationCircleSolid,
  endCall: faPhoneHangup,
  fileSolid: faFileSolid,
  fileUpload: faFileUpload,
  flagSolid: faFlagSolid,
  grid2: faThLarge,
  galleryView: faGrid2,
  helpSolid: faQuestionCircleSolid,
  homeSolid: faHomeSolid,
  indent: faIndent,
  infoSolid: faInfoCircle,
  insightsSolid: faLightbulbOnSolid,
  keyboardSolid: faKeyboard,
  keySolid: faKeySolid,
  list: faList,
  listUl: faListUl,
  locationSolid: faLocationSolid,
  lockSolid: faLockSolid,
  mailSolid: faEnvelopeSolid,
  menu: faEllipsisV,
  minimizeScreen: faCompressArrowsAlt,
  moreMenu: faEllipsisH,
  muteSolid: faMicrophoneSlashSolid,
  notificationSolid: faBell,
  notificationOffSolid: faBellSlash,
  orderedList: faListOl,
  pauseSolid: faPauseSolid,
  penSolid: faPenSolid,
  phoneSolid: faPhoneSolid,
  phonePlusSolid: faPhonePlusSolid,
  playSolid: faPlaySolid,
  question: faQuestion,
  rectangleWide: faRectangleWide,
  removeSolid: faTimesCircleSolid,
  replySolid: faReplySolid,
  settingsSolid: faCog,
  smileSolid: faSmileSolid,
  smsSolid: faCommentDotsSolid,
  starSolid: faStarSolid,
  stopSolid: faStopSolid,
  tasks: faTasks,
  teamSolid: faUsersSolid,
  thumbsDownSolid: faThumbsDownSolid,
  thumbsUpSolid: faThumbsUpSolid,
  unmuteSolid: faMicrophoneSolid,
  arrowUp: faArrowUpSolid,
  addParticipantSolid: faUserPlusSolid,
  userSolid: faUserSolid,
  usersSolid: faUserFriendsSolid,
  videoOffSolid: faVideoOffSolid,
  videoOnSolid: faVideoOnSolid,
  voicemailSolid: faVoicemailSolid,
  volumeSolid: faVolume,
  telephone: faPhoneOffice,
  admin: faUserCog,
  replyAllSolid: faReplyAll,
  faArrowCircleLeftSolid,
  faCircleSolid,
  faDizzySolid,
  faFrownOpenSolid,
  faGrimaceSolid,
  faGrinBeamSolid,
  faGrinSolid,
  faGrinStarsSolid,
  faGripVerticalSolid,
  faHeartSolid,
  faKissWinkHeartSolid,
  faMehSolid,
  faSadTearSolid,
  faSmileBeamSolid,
  faPaperPlaneSolid,
  faSearchSolid,
  faArrowLeftSolid,
  upgrade: faSparkles,
  callCenter: faHeadsetSolid,
  shieldCheck: faShieldCheck,
  shieldExclamation: faShieldExclamation,
  WifiExclamation: faWifiExclamation,
  faSquareB,
  imageSolid: faImage,
  gripDotsVertical: faGripDotsVertical,
  missedCallSolid: faPhoneSlash,
};

export { proSolidSvgIcons };
